"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pietracamela": {
    "a6349435": [{
      "hkey": "70ffc505",
      "slug": "pietracamela",
      "name": "Pietracamela",
      "primary": true,
      "skipSearch": false
    }],
    "intermesoli": [{
      "hkey": "70ffc505",
      "slug": "pietracamela",
      "name": "Pietracamela",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0fe83e02": [{
      "hkey": "70ffc505",
      "slug": "pietracamela",
      "name": "Pietracamela",
      "primary": true,
      "skipSearch": false
    }],
    "prati-di-tivo": [{
      "hkey": "70ffc505",
      "slug": "pietracamela",
      "name": "Pietracamela",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;